export default "__VITE_ASSET__DToTyXq4__"